class AnnouncementShippingThreshold extends HTMLElement {
  connectedCallback() {
    this.renderAmount();
  }

  renderAmount() {
    const baseAmount = Number(this.dataset.amount);
    const baseCurrency = this.dataset.baseCurrency;
    const activeCurrency = window.Shopify?.currency?.active || this.dataset.currency;
    const rate = activeCurrency === baseCurrency ? 1 : Number(window.Shopify?.currency?.rate);
    if (!Number.isFinite(baseAmount) || !Number.isFinite(rate) || rate <= 0) return;
    const convertedAmount = Math.ceil(baseAmount * rate);
    this.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: activeCurrency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(convertedAmount);
  }
}
if (!customElements.get('announcement-shipping-threshold')) {
  customElements.define('announcement-shipping-threshold', AnnouncementShippingThreshold);
}
